import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconGraduationCapAlt = (props) => (
  <SVG
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1965_1361)">
      <path
        d="M18.3808 4.35833L12.2358 1.43083C10.8831 0.622866 9.19953 0.60853 7.83328 1.39333L1.61914 4.35833C1.59582 4.37001 1.57164 4.38251 1.54914 4.39583C0.0744497 5.23904 -0.437504 7.11806 0.4057 8.59275C0.69152 9.09267 1.11195 9.50228 1.61914 9.77501L3.33332 10.5917V14.675C3.33433 16.5009 4.52242 18.114 6.26582 18.6567C7.47906 19.0077 8.73707 19.1795 10 19.1667C11.2627 19.1808 12.5207 19.0104 13.7342 18.6609C15.4776 18.1183 16.6657 16.5051 16.6667 14.6792V10.59L18.3334 9.79333V16.6667C18.3334 17.1269 18.7064 17.5 19.1667 17.5C19.6269 17.5 20 17.1269 20 16.6667V6.66665C20.0055 5.6881 19.2329 4.78412 18.3808 4.35833ZM15 14.6792C15.0004 15.7713 14.2918 16.7374 13.25 17.065C12.1935 17.3669 11.0987 17.5134 9.99996 17.5C8.90125 17.5134 7.80644 17.3669 6.74996 17.065C5.70812 16.7374 4.99953 15.7713 4.99996 14.6792V11.3859L7.76414 12.7026C8.44617 13.1076 9.22511 13.3204 10.0183 13.3184C10.7733 13.3237 11.5156 13.1238 12.1658 12.7401L15 11.3858V14.6792ZM17.6666 8.27083L11.3816 11.2708C10.5053 11.7811 9.4191 11.7667 8.55664 11.2333L2.40746 8.30833C1.72203 7.93872 1.46601 7.08345 1.83562 6.39806C1.96062 6.16626 2.14804 5.97412 2.37664 5.84333L8.62246 2.86001C9.49906 2.35087 10.5847 2.36529 11.4475 2.89751L17.5925 5.82501C18.0444 6.07595 18.3271 6.54982 18.3333 7.06669C18.3341 7.5563 18.082 8.01162 17.6666 8.27083Z"
        fill="#434B5D"
      />
    </g>
    <defs>
      <clipPath id="clip0_1965_1361">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
)

export default withIconStyles(IconGraduationCapAlt)
